import React from "react";
import { useDispatch } from "react-redux";
import { Route, HashRouter as Router, Switch } from "react-router-dom";

import { setAuth } from "./authSlice";
import HomeRouter from "./home/Index";
import JobFairRouter from "./job-fair/Index";
import MessageRouter from "./message/Index";
import RecruitRouter from "./recruit/Index";
import RecruitmentRouter from "./recruitment/Index";
import UserRouter from "./user/Index";
import LogIn from "./user/LogIn";
import Recover from "./user/Recover";
import SignIn from "./user/SignIn";

export default function App() {
  const reduxDispatch = useDispatch();
  const auth = JSON.parse(localStorage.getItem("auth"));
  if (auth !== null && auth.id) {
    reduxDispatch(
      setAuth({
        id: auth.id,
        uuid: auth.uuid,
        name: auth.name,
        email: auth.email,
        phone: auth.phone,
        wx_openid: auth.wx_openid,
      }),
    );
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <HomeRouter />
        </Route>
        <Route path="/主页">
          <HomeRouter />
        </Route>
        <Route path="/登录">
          <LogIn />
        </Route>
        <Route path="/注册">
          <SignIn />
        </Route>
        <Route path="/忘记密码">
          <Recover />
        </Route>
        <Route path="/岗位">
          <RecruitmentRouter />
        </Route>
        <Route path="/校园招聘">
          <RecruitRouter />
        </Route>
        <Route path="/消息">
          <MessageRouter />
        </Route>
        <Route path="/我的">
          <UserRouter />
        </Route>
        <Route path="/招聘会">
          <JobFairRouter />
        </Route>
      </Switch>
    </Router>
  );
}
